var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlexboxLayout',{staticClass:"loader",attrs:{"justifyContent":"center","alignContent":"center","role":"status","aria-live":"polite","aria-label":"Daten werden geladen"}},[_c('ActivityIndicator',{attrs:{"busy":"true","color":_vm.color,"aria-hidden":"true"}}),_c('span',{staticClass:"sr-only"},[_vm._v("Daten werden geladen...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }